export default "__VITE_ASSET__DKpNp_ZA__"